import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import PodcastEpisodesSection from '../../shared/PodcastEpisodesSection';
import {
  getLatestPodcasts,
  normalizeLatestPodcasts,
} from '../../../services/api/contentLatestPodcasts';
import type { PodcastEpisodeItem } from '../../shared/PodcastEpisodesSection/PodcastEpisodesSection.types';
import { selectBlockData } from '../ssrData';

const PROGRAMS_PATH = '/podcasts';
const BLOCK_TITLE = 'Podcast';
const BLOCK_SUBTITLE = 'As vozes da Rádio MEC, agora em podcast';
const BLOCK_ACTION_LABEL = 'Ver todos';

type Props = {
  data?: Record<string, unknown>;
  isEditMode?: boolean;
  block?: string;
};

function normalizeItems(data: unknown): PodcastEpisodeItem[] {
  return normalizeLatestPodcasts(data).map((item) => ({
    '@id': item['@id'] || '',
    title: item.title || '',
    image: item.image || '',
    imageVersion: item.imageVersion,
    programTitle: item.type_title || '',
    audio: item.audio || '',
  }));
}

export default function PodcastEpisodesView(props: Props) {
  const { isEditMode, block } = props;
  const preloadedData = useSelector((state: any) =>
    selectBlockData(state, block, 'podcastEpisodes'),
  );
  const hasPreloadedData = Array.isArray(preloadedData);

  const [items, setItems] = useState<PodcastEpisodeItem[]>(() =>
    normalizeItems(preloadedData),
  );
  const [loading, setLoading] = useState<boolean>(!hasPreloadedData);

  useEffect(() => {
    if (hasPreloadedData) {
      setItems(normalizeItems(preloadedData));
      setLoading(false);
      return;
    }

    let isCancelled = false;

    async function loadData() {
      setLoading(true);

      try {
        const result = await getLatestPodcasts();

        if (!isCancelled) {
          setItems(normalizeItems(result));
        }
      } catch (error) {
        console.error('Falha ao carregar bloco de podcasts', error);

        if (!isCancelled) {
          setItems([]);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    }

    loadData();

    return () => {
      isCancelled = true;
    };
  }, [hasPreloadedData, preloadedData]);

  if (!loading && !items.length && !isEditMode) {
    return null;
  }

  return (
    <PodcastEpisodesSection
      title={BLOCK_TITLE}
      subtitle={BLOCK_SUBTITLE}
      href={PROGRAMS_PATH}
      actionLabel={BLOCK_ACTION_LABEL}
      items={items}
      loading={loading}
      emptyMessage="Nenhum episódio de podcast encontrado"
      isEditMode={isEditMode}
    />
  );
}
